import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import RedesignShell from './components/redesign/RedesignShell.jsx';
import { HomeA } from './pages/redesign/HomeRedesign.jsx';
import { BlogA } from './pages/redesign/BlogRedesign.jsx';
import { ServicesA } from './pages/redesign/ServicesRedesign.jsx';
import { OpenSourceA } from './pages/redesign/OpenSourceRedesign.jsx';
import { UseCasesListA, UseCaseDetailA } from './pages/redesign/UseCasesRedesign.jsx';
import { ContactA } from './pages/redesign/ContactRedesign.jsx';
import { ServiceSubpageA } from './pages/redesign/ServiceSubpageRedesign.jsx';
import { TunnelrA } from './pages/redesign/TunnelrRedesign.jsx';
import { LLMWikiLeadMagnetA } from './pages/redesign/LLMWikiLeadMagnetRedesign.jsx';
import NotFound from './pages/NotFound.jsx';

// Blog posts imported eagerly. React.lazy + prerender + React 18 hydration
// causes mismatches at the Suspense boundary; static imports keep hydration clean.
// Vite still code-splits per-page chunks via its build pipeline.
import SuiteCRMAIAge from './pages/blogs/SuiteCRMAIAge.jsx';
import CRMProcessNotSoftware from './pages/blogs/CRMProcessNotSoftware.jsx';
import DonorRetentionSuiteCRM from './pages/blogs/DonorRetentionSuiteCRM.jsx';
import ModernizingBusinessOperations from './pages/blogs/ModernizingBusinessOperations.jsx';
import OpenClawSuiteCRMIntegration from './pages/blogs/OpenClawSuiteCRMIntegration.jsx';
import SuiteCRM8DockerizedEnvironment from './pages/blogs/SuiteCRM8DockerizedEnvironment.jsx';
import LLMWikiCRMBlog from './pages/blogs/LLMWikiCRMBlog.jsx';

const RedesignHome = () => (
  <RedesignShell>{({ onNav }) => <HomeA onNav={onNav} />}</RedesignShell>
);
const RedesignResources = () => (
  <RedesignShell>{({ onNav }) => <BlogA onNav={onNav} />}</RedesignShell>
);
const RedesignServices = () => (
  <RedesignShell>{({ onNav }) => <ServicesA onNav={onNav} />}</RedesignShell>
);
const RedesignOpenSource = () => (
  <RedesignShell>{({ onNav }) => <OpenSourceA onNav={onNav} />}</RedesignShell>
);
const RedesignUseCases = () => (
  <RedesignShell>{({ onNav }) => <UseCasesListA onNav={onNav} />}</RedesignShell>
);
const RedesignUseCaseDetail = () => (
  <RedesignShell>{({ onNav }) => <UseCaseDetailA onNav={onNav} />}</RedesignShell>
);
const RedesignContact = () => (
  <RedesignShell>{({ onNav }) => <ContactA onNav={onNav} />}</RedesignShell>
);
const RedesignServiceSubpage = ({ slug }) => (
  <RedesignShell>{({ onNav }) => <ServiceSubpageA slug={slug} onNav={onNav} />}</RedesignShell>
);
const RedesignTunnelr = () => (
  <RedesignShell>{({ onNav }) => <TunnelrA onNav={onNav} />}</RedesignShell>
);
const RedesignLLMWiki = () => (
  <RedesignShell>{({ onNav }) => <LLMWikiLeadMagnetA onNav={onNav} />}</RedesignShell>
);

const App = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location]);

  return (
    <Routes>
        <Route path="/" element={<RedesignHome />} />
        <Route path="/services" element={<RedesignServices />} />
        <Route path="/services/suitecrm-implementation" element={<RedesignServiceSubpage slug="implementation" />} />
        <Route path="/services/suitecrm-customisation" element={<RedesignServiceSubpage slug="customisation" />} />
        <Route path="/services/crm-integration" element={<RedesignServiceSubpage slug="integration" />} />
        <Route path="/services/ai-workflow-automation" element={<RedesignServiceSubpage slug="ai" />} />
        <Route path="/services/suitecrm-support" element={<RedesignServiceSubpage slug="support" />} />
        <Route path="/solutions" element={<Navigate to="/services" replace />} />
        <Route path="/opensource" element={<RedesignOpenSource />} />
        <Route path="/suitecrm" element={<Navigate to="/opensource" replace />} />
        <Route path="/developers" element={<Navigate to="/opensource" replace />} />
        <Route path="/use-cases" element={<RedesignUseCases />} />
        <Route path="/use-cases/:slug" element={<RedesignUseCaseDetail />} />
        <Route path="/resources" element={<RedesignResources />} />
        <Route path="/resources/llm-wiki-crm" element={<RedesignLLMWiki />} />
        <Route path="/contact" element={<RedesignContact />} />
        <Route path="/contact-us" element={<Navigate to="/contact" replace />} />
        <Route path="/tunnelr" element={<RedesignTunnelr />} />
        {/* Individual blog post routes */}
        <Route path="/blog/suitecrm-ai-age" element={<SuiteCRMAIAge />} />
        <Route path="/blog/crm-process-not-software" element={<CRMProcessNotSoftware />} />
        <Route path="/blog/donor-retention-suitecrm" element={<DonorRetentionSuiteCRM />} />
        <Route path="/blog/modernizing-business-operations" element={<ModernizingBusinessOperations />} />
        <Route path="/blog/openclaw-suitecrm-integration" element={<OpenClawSuiteCRMIntegration />} />
        <Route path="/blog/suitecrm-8-dockerized-environment" element={<SuiteCRM8DockerizedEnvironment />} />
        <Route path="/blog/llm-wiki-crm" element={<LLMWikiCRMBlog />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
  );
};

export default App;
